import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100 mt-auto">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="flex flex-col sm:flex-row flex-wrap gap-8 md:gap-12 justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500">
                <i className="ri-camera-3-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">无节操摄影部</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              一个专注于创意与趣味摄影的交流社区，汇聚摄影爱好者的作品、技巧与讨论，让每一次按下快门都值得被看见。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">
              <a href="/tutorials" className="hover:text-primary-400 cursor-pointer">热门分类</a>
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 5).map((c) => (
                <li key={c.id}>
                  <Link to={`/category/${c.id}`} className="text-sm text-background-300 hover:text-primary-400 cursor-pointer whitespace-nowrap">
                    {c.name}摄影
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">
              <a href="/forum" className="hover:text-primary-400 cursor-pointer">快速导航</a>
            </h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/" className="text-sm text-background-300 hover:text-primary-400 cursor-pointer">首页</Link></li>
              <li><Link to="/tutorials" className="text-sm text-background-300 hover:text-primary-400 cursor-pointer">摄影技巧</Link></li>
              <li><Link to="/forum" className="text-sm text-background-300 hover:text-primary-400 cursor-pointer">社区讨论</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">
              <a href="/about" className="hover:text-primary-400 cursor-pointer">关注我们</a>
            </h4>
            <div className="flex gap-3">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-mail-line', 'ri-instagram-line'].map((icon) => (
                <span key={icon} className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-600 transition-colors cursor-pointer">
                  <i className={`${icon} text-background-100 text-base`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 无节操摄影部. 保留所有权利.</p>
          <p>内容仅供演示交流，图片版权归原作者所有</p>
        </div>
      </div>
    </footer>
  );
}